<template>
<div>
	<section>
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<!-- <div class="section-title">
		                PROGRAMS

		                	
		                <router-link :to="{ name : 'sme.courses.create' }" tag="a" class="ml-2 button buttton-small small-button">
							    	<img src="../../assets/images/icons/solid/plus_white.svg" width="14" />
									new
								</router-link>

						
		                <span class="float-right">
			                <span @click="changeView('mosaic')" :class="{ 'active' : active_view == 'mosaic' }" class="program-list-option">
			                	<img width="20" class="mr-2" src="../../assets/images/icons/solid/th-large.svg">
			                </span>
			                <span @click="changeView('table')" :class="{ 'active' : active_view == 'table' }" class="program-list-option">
			                	<img width="20" class="mr-2" src="../../assets/images/icons/solid/list.svg">
			                </span>
			            </span>
			   
			        </div> -->

			        <!-- table view -->
			        <div class="row" v-if="active_view == 'table'">
						<sme-table :table_body_data="courses" :table_headers="['ID','Program','AgencyConnection','Notes','Agencies','Modules','Created on','Actions']" @searchCourses="searchCourses"
						@showModalDelete="showModalDelete"
						@showModalDuplicate="showModalDuplicate"
						></sme-table>
			        </div>

			        <!-- mosaic view -->
			        <div class="row" v-if="active_view == 'mosaic'">
			        	<div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
			                <div class="banner d-flex">
			                	<router-link tag="a" :to="{ name : 'sme.courses.create' }" class="d-flex justify-content-center align-items-center green-content">
				                	<div class="caption">
					                	<div class="title">Add new program</div>
					                	<div class="subtitle"><img src="../../assets/images/icon_plus_circle_white.svg" width="40" /></div>
				                	</div><!--caption-->
			                	</router-link>
			                </div>
			            </div><!--col-->
			            
			            <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex" v-for="course in courses">
			                <div class="banner d-flex">
			                	<router-link tag="a" :to="{ name : 'sme.courses.edit', params : { id : course.id } }" class="d-flex justify-content-center align-items-center">
			                		<span class="status edit">{{ course.status }}</span>
				                	<div class="thumb-container" :style="{ 'background-image' : 'url('+course.image+')' }"></div>
				                	<div class="caption">
					                	<div class="title">{{ course.name }}</div>
					                	<div class="subtitle">{{ course.description }}</div>
				                	</div><!--caption-->
			                	</router-link>
			                </div>
			            </div><!--col--> 
			        </div><!--row-->
				</div><!--col-->
			</div><!--row-->


			<!-- modals -->
			<sme-modals :show_duplicate_course="show_duplicate_course"
			:show_delete_course="show_delete_course"
			:course_to_duplicate="course_to_duplicate"
			:course_to_delete="course_to_delete"
			@duplicateCourse="duplicateCourse"
			@deleteCourse="deleteCourse"
			></sme-modals>
		</div><!--container_fluid-->
	</section>
</div>
</template>

<script>
	export default{
		data : function(){
			return {
				courses : [],
				active_view : 'table',

				course_to_delete : null,
				show_delete_course : false,

				course_to_duplicate : null,
				show_duplicate_course : false,

				search : '',
				timeout_search : null,
			}
		},

		created : function(){
			this.getCourses();
		},
		methods : {
			getCourses : function(key_search){
				if(key_search == undefined){
					key_search = ''
				}
				var params = {
					filters : {
						page : this.current_page,
						search : key_search
					}
				}
				this.$store.dispatch('getCourses', params).then((res) => {
					this.courses = res.data.data;

				}).catch((error) => {
					console.log(error);
				});
			},

			changeView : function(view){
				this.active_view = view;
			},

			showModalDelete : function(course){
				this.course_to_delete = course;
				this.show_delete_course = true;
			},

			deleteCourse : function(){
				this.show_delete_course = false
				this.course_to_delete = null;
				this.getCourses();
			},

			showModalDuplicate : function(course){
				this.course_to_duplicate = course;
				this.show_duplicate_course = true;
			},

			duplicateCourse : function(){
				this.course_to_duplicate = null
				this.show_duplicate_course = false
			},

			searchCourses : function(key_search){
				clearInterval(this.timeout_search);

				this.timeout_search = setTimeout(() => {
					this.getCourses(key_search);
				}, 500);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/sme/SMEDashboardComponent.vue